import { Model } from '@nozbe/watermelondb';
import { field } from '@nozbe/watermelondb/decorators';

export class ConditionalModel extends Model {
  static table = 'conditionals';

  @field('type_answers_id')
  type_answers_id!: number;

  @field('question_id')
  question_id!: number;

  @field('order')
  order!: number;

  @field('created_by')
  created_by!: string;

  @field('updated_by')
  updated_by!: string;

  @field('created_at')
  created_at!: number;

  @field('updated_at')
  updated_at!: number;
}
